const enableNode = document.querySelector( '#wcbt_quick_view_enable' );
const enableToolTipNode = document.querySelector( '#wcbt_quick_view_tooltip_enable' );
const tooltipTextNode = document.querySelector( '#wcbt_quick_view_tooltip_text' );

const wcbtQuickView = () => {
	enableField();
};

const enableField = () => {
	if ( ! enableNode ) {
		return;
	}

	handle( enableNode );
	enableNode.addEventListener( 'change', function( event ) {
		handle( this );
	} );
};

const handle = ( enableNode ) => {
	const fieldWrapperNodes = document.querySelectorAll( '.wcbt-field-wrapper' );

	if ( ! fieldWrapperNodes ) {
		return;
	}
	const enableFieldWrapperNode = enableNode.closest( '.wcbt-field-wrapper' );
	for ( let i = 0; i < fieldWrapperNodes.length; i++ ) {
		const fieldWrapperNode = fieldWrapperNodes[ i ];
		if ( fieldWrapperNode === enableFieldWrapperNode ) {
			continue;
		}

		if ( enableNode.checked ) {
			fieldWrapperNode.style.display = 'flex';
			enableToolTip();
		} else {
			fieldWrapperNode.style.display = 'none';
		}
	}
};

const handleEnableTooltip = ( enableToolTipNode ) => {
	if ( ! tooltipTextNode ) {
		return;
	}

	const field = tooltipTextNode.closest( '.wcbt-field-wrapper' );
	if ( enableToolTipNode.checked ) {
		field.style.display = 'flex';
	} else {
		field.style.display = 'none';
	}
};

const enableToolTip = () => {
	if ( ! enableToolTipNode ) {
		return;
	}

	handleEnableTooltip( enableToolTipNode );
	enableToolTipNode.addEventListener( 'change', function( event ) {
		handleEnableTooltip( this );
	} );
};

export default wcbtQuickView;
